// extracted by mini-css-extract-plugin
export default {"badge":"ItemAvailabilityBadge_badge__u9QzT","clickable":"ItemAvailabilityBadge_clickable__60w22"};